<template>
  <div class="user-info" v-if="serviceInfo">
    <div class="user">
      <img :src="serviceInfo.headImg" />
      <div class="item-box">
        <p>{{serviceInfo.realName}}</p>
        <el-dropdown @command="handleCommand1">
          <el-button type="text">{{serviceInfo.workStatus === 10?'在线':(serviceInfo.workStatus === 20?'离线':'离开')}}<i class="el-icon--right el-icon-arrow-down"></i></el-button>
          <el-dropdown-menu slot="dropdown" v-hasPermi="['customer:personnel:status']">
            <!-- workStatus  在线 10 离线 20 离开 30-->
            <el-dropdown-item :command="beforeHandleCommand1(serviceInfo,1)" v-if="serviceInfo.workStatus != 10">上线</el-dropdown-item>
            <el-dropdown-item :command="beforeHandleCommand1(serviceInfo,2)" v-if="serviceInfo.workStatus != 20">离线</el-dropdown-item>
            <el-dropdown-item :command="beforeHandleCommand1(serviceInfo,3)" v-if="serviceInfo.workStatus != 30">离开</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <span>{{serviceInfo.workStatus === 10?'在线':(serviceInfo.workStatus === 20?'离线':'离开')}}</span> -->
      </div>

    </div>
    <!-- <el-dropdown @command="handleCommand">
      <el-button type="text">...<i class="el-icon--right el-icon-arrow-down"></i></el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command="beforeHandleCommand(1)">开启自动回复</el-dropdown-item>
        <el-dropdown-item :command="beforeHandleCommand(2)">开启聊天提醒</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
  </div>
</template>

<script>
import custServiceStaffApi from '@/api/customer/custServiceStaff'
export default {
  props: ['serviceInfo'],
  data() {
    return {
      search: '',
      active: false,
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    beforeHandleCommand1(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand1(command) {
      let id = [command.row.id]
      if (command.command === 1) {
        this.batchSetWorkStatus(id, 10)
      } else if (command.command === 2) {
        this.batchSetWorkStatus(id, 20)
      } else if (command.command === 3) {
        this.batchSetWorkStatus(id, 30)
      }
    },
    batchSetWorkStatus(ids, status) {
      custServiceStaffApi.setWorkStatusBatch({ ids: ids, workStatus: status }).then(() => {
        this.$common.showMsg('success', '操作成功')
        this.serviceInfo.workStatus = status
      })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (command.command === 1) {
      } else if (command.command === 2) {

      }
    },

  }
}
</script>

<style lang="scss" scoped>
.user-info {
  // padding-bottom: 13px;
  position: relative;
  padding: 20px 20px 13px;
  border-bottom: 1px solid rgba(197, 197, 197, 0.8);
  // &::before {
  //   content: '';
  //   position: absolute;
  //   left: -20px;
  //   right: -20px;
  //   bottom: 0;
  //   height: 1px;
  //   background: rgba(197, 197, 197, 0.8);
  // }
  .user {
    display: flex;

    img {
      width: 46px;
      height: 46px;
      border-radius: 50%;
    }
    .item-box {
      padding-left: 10px;
      p {
        font-size: 14px;
        margin: 0;
        // padding-bottom: 9px;
      }
      span {
        font-size: 14px;
        color: #1596cd;
        position: relative;
        &::before {
          content: '';
          position: absolute;
          right: -12px;
          top: 6px;
          border: solid #6c6c6c;
          border-width: 0 1px 1px 0;
          display: inline-block;
          padding: 3px;
          transform: rotate(-45deg);
          -webkit-transform: rotate(-45deg);
        }
      }
    }
  }
  // .el-dropdown {
  //   position: absolute;
  //   right: 20px;
  //   top: 12px;
  //   .el-button--text {
  //     font-size: 24px;
  //     .el-icon--right {
  //       display: none;
  //     }
  //   }
  // }
}
</style>